/* eslint-disable react/display-name */
import { lazy } from "react";
const CallCenterLogPage = lazy(() => import("../admin/pages/call-center"));
const UserCallCenterPage = lazy(() => import("./pages/user-manage"));
const SchemaCallCenterPage = lazy(() => import("./pages/schema-manage"));
const TenantCallCenterPage = lazy(() => import("./pages/tenant-manage"));
const PhoneEndPointPage = lazy(() => import("./pages/phone-endpoint"));
const TrunkManagePage = lazy(() => import("./pages/trunk-manage"));
const CallCenterDownloadPage = lazy(() => import("./pages/download"));

const CallCenterRoutes = [
  { path: "log", element: <CallCenterLogPage /> },
  { path: "user-manage", element: <UserCallCenterPage /> },
  { path: "schema-manage", element: <SchemaCallCenterPage /> },
  { path: "tenant-manage", element: <TenantCallCenterPage /> },
  { path: "phone-endpoint", element: <PhoneEndPointPage /> },
  { path: "trunk-manage", element: <TrunkManagePage /> },
  { path: "download", element: <CallCenterDownloadPage /> }
];

export default CallCenterRoutes;
